import React, { useContext, useEffect, useState } from "react";
import SearchFilter from "./SearchFilter";
import Text from "../../Tags/Text";
import { Button } from "../../ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useMutation } from "react-query";
import { isCompanyInCRM } from "../../../apis/workspace/general";
import SharedDataContext from "../../../SharedDataContext";
import RecordRow from "./RecordRow";
import { crmRecordKeyValue, isEmptyObject } from "../../../utils/GenericFn";
import { getSavedCRMConfig } from "../../../apis/workspace/integrations";
import Image from "../../Tags/Image";
import NoData from "../../NoData";
import CreateCompanyRecord from "./CreateCompanyRecord";
import { Checkbox } from "../../ui/checkbox";
import { Skeleton } from "../../ui/skeleton";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { useStoreCRMSearch } from "../../../stores/useStoreCRMSearch";
import { useStoreCRMConfig } from "../../../stores/useStoreCRMConfig";
import { searchCRMRecords } from "../../../apis/crm";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function CompanyRecords({
  searchFilter,
  companyId,
  type = "company",
  hideCompanyRecords,
  submitFromCompanyRecord,
  openCreateRecord = false,
  getGeneratedPayload,
  initialPayloadforForm,
  initCompanyId,
  activeCRMIntegration,
}) {
  const {
    addChunkInCRMBulkSearchData,
    crmBulkSearchData,
    setCRMBulkSearchPayload,
    isCRMBulkSearchLoading,
    isCRMBulkSearchFetched,
    getCRMSearchRecordById,
  } = useStoreCRMSearch();

  const navigate = useNavigate();
  const [create, setCreate] = useState(openCreateRecord);
  const [searchFilterData, setSearchFilterData] = useState(searchFilter);
  const captureEvent = useCaptureEvent();

  console.log("searchFilterData in company records", searchFilter);

  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const crmConfigId =
    activeWorkspace?.preferences && activeWorkspace?.preferences?.active_crm_workspace_integration_config_id;

  function flattenMappedData(input) {
    const result = {};

    Object.values(input).forEach((fieldGroup) => {
      if (fieldGroup && typeof fieldGroup === "object") {
        Object.entries(fieldGroup).forEach(([key, value]) => {
          result[key] = value;
        });
      }
    });

    return result;
  }

  // search company in crm
  const [matchedObj, setMatchedObj] = useState({});
  const [diffData, setDiffData] = useState({});
  const [allRecordsWithApiName, setAllRecordsWithApiName] = useState([]);
  const [allRecordsWithApiNameError, setAllRecordsWithApiNameError] = useState([]);

  const processOrgSearchData = (chunk) => {
    console.log("📥 Streamed chunk:", chunk);

    // addChunkInCRMBulkSearchData(chunk);
    let data = chunk?.data;
    if (data && data.length > 0) {
      console.log(data);

      const result = data.flatMap((item) =>
        Array.isArray(item.records) && item.records.length > 0
          ? item.records.map((record) => ({
              ...record,
              apiName: item.crm_object_api_name,
              apiNameLabel: item?.crm_object_label,
              search_filters_applied: item?.search_filters_applied,
            }))
          : []
      );

      const matchedObj =
        result && result.length > 0
          ? result
              .filter((obj) => obj.match_confirmed)
              .sort((a, b) => new Date(b.record_created_at) - new Date(a.record_created_at))[0]
          : undefined;

      setMatchedObj(matchedObj);
      setSelectedCompanyId(matchedObj?.Id);

      const resultWithError = data.filter((item) => item.error);

      console.log("setAllRecordsWithApiName", result);

      setAllRecordsWithApiNameError(resultWithError);
      setAllRecordsWithApiName(result);
      if (result && result.length > 0 && initCompanyId) {
        setSelectedCompanyId(initCompanyId);
      }
      console.log("data in company");
      if (data && data.length > 0 && data[0].search_filters_applied) {
        setSearchFilterData(data[0].search_filters_applied);
      }
    }
  };

  const isCompanyInCRMFn = useMutation(
    ({ data, configId, options }) =>
      searchCRMRecords({
        data,
        configId,
        options,
        onStream: (chunk) => {
          processOrgSearchData(chunk);
          addChunkInCRMBulkSearchData(chunk);
        },
      }),
    {
      onError(err) {
        console.error("❌ Bulk search stream error:", err);
      },
    }
  );

  const handleIsCompanyInCRM = (searchParams = {}) => {
    if (isCompanyInCRMFn.isLoading) {
      return;
    }
    let payload = [
      {
        organization_id: companyId,
        type: "company",
        edit_search: true,
        search_params: searchParams ? searchParams : flattenMappedData(searchFilterData),
      },
    ];
    console.log("payload", payload);
    if (isEmptyObject(payload[0].search_params)) {
      delete payload[0].search_params;
    }

    console.log("recordData", payload);

    isCompanyInCRMFn.mutate({
      data: payload,
      configId: crmConfigId,

      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    console.log("crmBulkSearchData i nn", crmBulkSearchData);
    if (!companyId) {
      return;
    }
    console.log("getCRMSearchRecordById(companyId)?.records", getCRMSearchRecordById(companyId));
    processOrgSearchData({ recordId: companyId, data: getCRMSearchRecordById(companyId)?.records });
  }, [companyId]);

  //savedConfig
  const [companyWithWritePermission, setCompanyWithWritePermission] = useState([]);
  const [savedConfig, setSavedConfig] = useState([]);
  const [companyArr, setCompanyArr] = useState([]);
  const [personArr, setPersonArr] = useState([]);

  // get crm object list
  // const getSavedCRMConfigFn = useMutation("get_saved_crm_object", getSavedCRMConfig, {
  //   onSuccess(data, variables, context) {
  //     // console.log("savedConfig", data);
  //     if (data && data.data && data.data.length > 0) {
  //       const arrCompany = data?.data.filter((obj) => obj.type === "company");
  //       const arrPeople = data?.data.filter((obj) => obj.type === "person");
  //       setSavedConfig(data.data);
  //       // console.log("arrPeople", arrPeople);
  //       setPersonArr(arrPeople);
  //       setCompanyArr(arrCompany);

  //       const arr_c = data.data.filter((obj) => obj.type === "company" && obj.permission?.create === true);
  //       setCompanyWithWritePermission(arr_c);
  //     }
  //   },
  // });

  const {
    savedCRMConfig,
    savedCompanyConfig,
    savedCompanyConfigWithWritePermission,
    savedCompanyConfigObj,
    savedPeopleConfig,
    savedPeopleConfigWithWritePermission,
  } = useStoreCRMConfig();

  const [checkedApiName, setCheckedApiName] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState(initCompanyId);
  const [selectedCompanyApiName, setSelectedCompanyApiName] = useState("");
  const query = useQueryParams();

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <Text size="lg">Associate Account to Contacts</Text>
          <Text size="p" className="mt-1">
            Choose the account in CRM that will be linked to the created contacts
          </Text>
        </div>
        {/* <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <Button
            variant="danger-outline"
            type="button"
            onClick={() => {
              navigate(`/${activeWorkspace?.slug}/companies/${query?.callbackUrl}`);
            }}
          >
            <ArrowLeft className="h-5 w-5 mr-2" aria-hidden="true" />
            Cancel and go back
          </Button>
        </div> */}
      </div>
      <SearchFilter
        searchFilter={searchFilter || searchFilterData}
        submitFilter={(values) => {
          console.log("submit", values);
          setCreate(false);
          handleIsCompanyInCRM(values);
          captureEvent("ECRM_AssociateAccount_SearchSubmit", {
            company_id: companyId,
            type: type,
          });
        }}
      />
      {isCompanyInCRMFn.isLoading && [1, 2, 3].map((el) => <Skeleton className="h-[230px] my-4" />)}
      {create && allRecordsWithApiName.length > 0 && (
        <>
          <Button
            variant="purple-outline"
            onClick={() => {
              setCreate(false);
              captureEvent("ECRM_AssociateAccount_SelectExistingClick", {
                company_id: companyId,
                type: type,
              });
            }}
            className="mt-4"
          >
            Select from existing {allRecordsWithApiName[0]?.apiNameLabel}s
          </Button>
        </>
      )}
      {!create && !isCompanyInCRMFn.isLoading && (
        <div>
          {allRecordsWithApiName.length > 0 && (
            <>
              {type === "company" &&
                Array.isArray(savedCompanyConfigWithWritePermission) &&
                savedCompanyConfigWithWritePermission.length > 0 && (
                  <Button
                    variant="purple-outline"
                    onClick={() => {
                      setCreate(true);
                      captureEvent("ECRM_AssociateAccount_CreateNewClick", {
                        company_id: companyId,
                        type: type,
                        account_name: searchFilter?.["name"]?.value,
                      });
                    }}
                    className="mt-4"
                  >
                    Create new {allRecordsWithApiName[0]?.apiNameLabel}: {searchFilter?.["name"]?.value}
                  </Button>
                )}
            </>
          )}
          <div className="h-[400px] overflow-y-scroll mt-4">
            {allRecordsWithApiName && allRecordsWithApiName.length > 0 && !isCompanyInCRMFn.isLoading ? (
              allRecordsWithApiName.map((item) => (
                <div className="p-4 border border-[#D0D5DD] bg-[#F9FAFB] rounded-xl mb-4">
                  <span className="flex w-full items-center justify-between space-x-2 mb-3">
                    <span className="inline-flex items-center space-x-2">
                      {" "}
                      {item?.match_confirmed ? (
                        <Image
                          src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                          className="h-4"
                        />
                      ) : (
                        <Image
                          src={`/images/crm/${activeCRMIntegration?.integration?.key}-gray.svg`}
                          className="h-4"
                        />
                      )}
                      <span className="text-[#101828] text-sm font-semibold">
                        {item?.Name ? (
                          item?.Name
                        ) : (
                          <>
                            {item?.data?.name?.value
                              ? item?.data?.name?.value
                              : `${item?.data?.first_name?.value} ${item?.data?.last_name?.value}`}
                          </>
                        )}
                      </span>
                    </span>
                    <input
                      checked={selectedCompanyId === item.Id}
                      onChange={() => {
                        console.log("selectedCompanyId id", item.Id);
                        console.log("selectedCompanyId", selectedCompanyId);
                        setSelectedCompanyId(item?.Id);
                        setSelectedCompanyApiName();
                        // if (selectedCompanyId && item.Id) {
                        //   setSelectedCompanyId("");
                        //   setSelectedCompanyApiName("");
                        // } else {
                        //   setSelectedCompanyId(item?.Id);
                        //   setSelectedCompanyApiName();
                        // }
                        captureEvent("ECRM_AssociateAccount_SelectAccount", {
                          company_id: companyId,
                          selected_record_id: item?.Id,
                          record_name: item?.Name,
                          type: type,
                        });
                      }}
                      type="checkbox"
                      className="mr-3 h-4 w-4 rounded border-gray-300 text-brand-700 focus:ring-brand-700 dark:text-brand-200"
                    />
                  </span>

                  <div className="border-b border-[#EAECF0] my-4"></div>
                  <div className="flex justify-between">
                    <span className="inline-flex items-center">
                      <span className="border border-[#D5D9EB] rounded-xl text-sm bg-transparent text-[#363F72] px-2">
                        {item?.apiNameLabel}
                      </span>
                      <a href={item?.record_url} target="_blank">
                        {" "}
                        <Image src="/images/crm/hyperlink.svg" />
                      </a>
                    </span>
                    {item?.match_confirmed ? (
                      <Image src="/images/crm/matched.svg" />
                    ) : (
                      <></>
                      // <button className="inline-flex justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-white border-[#D6BBFB] text-[#6941C6] px-4 py-2 h-8 rounded-[8px] font-semibold">
                      //   Match
                      // </button>
                    )}
                  </div>
                  <div className="mt-3">
                    {crmRecordKeyValue(type, item?.apiNameLabel, savedCRMConfig) &&
                      crmRecordKeyValue(type, item?.apiNameLabel, savedCRMConfig).length > 0 &&
                      crmRecordKeyValue(type, item?.apiNameLabel, savedCRMConfig).map((el) => {
                        if (el.system_field_name !== "location") {
                          return (
                            <div className="mb-3">
                              {el.system_field_name !== "crm_owner_name" && (
                                <RecordRow
                                  label={el?.label}
                                  value={
                                    el?.crm_field_api_name
                                      ? el.system_field_name === "company" && item?.crm_resolved_company_name
                                        ? item?.crm_resolved_company_name
                                        : item?.data?.[el.system_field_name]?.value
                                      : ""
                                  }
                                />
                              )}
                              {el.system_field_name === "crm_owner_name" && (
                                <RecordRow label={el?.label} value={item?.crm_owner_name} />
                              )}
                            </div>
                          );
                        }
                        if (el.system_field_name === "location") {
                          return (
                            <div className="mb-3">
                              <RecordRow
                                label={el?.label}
                                value={null}
                                location={true}
                                locationData={
                                  type === "company"
                                    ? {
                                        city: item?.data?.headquarters_city?.value,
                                        state: item?.data?.headquarters_state?.value,
                                        country: item?.data?.headquarters_country?.value,
                                      }
                                    : {
                                        city: item?.data?.city?.value,
                                        state: item?.data?.state?.value,
                                        country: item?.data?.country?.value,
                                      }
                                }
                              />
                            </div>
                          );
                        }
                      })}
                  </div>
                </div>
              ))
            ) : (
              <>
                {type === "company" &&
                  Array.isArray(savedCompanyConfigWithWritePermission) &&
                  savedCompanyConfigWithWritePermission.length > 0 && (
                    <button
                      onClick={() => {
                        setCreate(true);
                        captureEvent("ECRM_AssociateAccount_CreateNewClick", {
                          company_id: companyId,
                          type: type,
                          source: "no_matches_found",
                        });
                      }}
                      className="mt-4 mb-4 flex w-full justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-white border-[#D6BBFB] text-[#6941C6] px-4 py-2 h-9 rounded-[8px] font-semibold"
                    >
                      Create a new record
                    </button>
                  )}
                <NoData
                  heading="We couldn’t find any matches"
                  description="Edit the search criteria and try again"
                  imgWidth="w-6/12"
                />
              </>
            )}
          </div>
          <div className="sm:flex sm:items-center mt-6 justify-end">
            <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none space-x-2">
              <Button
                variant="secondary"
                type="button"
                onClick={() => {
                  hideCompanyRecords();
                  captureEvent("ECRM_AssociateAccount_CancelClick", {
                    company_id: companyId,
                    type: type,
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={selectedCompanyId === ""}
                type="button"
                onClick={() => {
                  if (savedCompanyConfig && savedCompanyConfig.length > 0) {
                    console.log("savedCompanyConfig", savedCompanyConfig);
                    submitFromCompanyRecord(selectedCompanyId, {
                      [savedCompanyConfig[0]?.crm_object_api_name]: selectedCompanyId,
                    });
                    captureEvent("ECRM_AssociateAccount_ContinueClick", {
                      company_id: companyId,
                      selected_record_id: selectedCompanyId,
                      type: type,
                    });
                  }
                }}
              >
                Continue
                <ArrowRight className="h-5 w-5 ml-2" aria-hidden="true" />
              </Button>
            </div>
          </div>
        </div>
      )}
      {create && savedCompanyConfig && savedCompanyConfig.length > 0 && (
        <CreateCompanyRecord
          initialPayloadforForm={initialPayloadforForm}
          generatePayload={true}
          getGeneratedPayload={(data) => {
            getGeneratedPayload(data);
            console.log("getGeneratedPayload", data);
            hideCompanyRecords();
          }}
          goBack={() => {
            if (openCreateRecord) {
              hideCompanyRecords();
            } else {
              setCreate(false);
            }
          }}
          infoData={{
            activeCrm: crmConfigId,
            record_id: companyId,
            crm_object_api_name: savedCompanyConfig[0]?.crm_object_api_name,
            crm_object_api_label: savedCompanyConfig[0]?.crm_object_api_label
              ? savedCompanyConfig[0]?.crm_object_api_label
              : "",
            type: type,
            activeWorkspaceId: activeWorkspace?.id,
          }}
          apiName={savedCompanyConfig[0]?.crm_object_api_name}
          checkedApiName={checkedApiName}
          onSuccess={(data) => {
            setCreate(false);
            handleIsCompanyInCRM();
          }}
        />
      )}
    </div>
  );
}
